/**
 * Stable CSS class names for E2E — Customer address information (paper + edit drawer).
 */
export const CAIP = {
    rootPaper: 'customer-address-information-paper',
    sectionTitle: 'customer-address-information-paper__section-title',
    gridWrapper: 'customer-address-information-paper__grid-wrapper',
    datagrid: 'customer-address-information-paper__datagrid',
    drawerBody: 'customer-address-information-paper__drawer-body',
    drawerForm: 'customer-address-information-paper__drawer-form',

    fieldAddressNumber: 'customer-address-information-field--address-number',

    inputTextfieldAddressDefinition: 'customer-address-information-input--textfield-address-definition',
    inputTextfieldFirstName: 'customer-address-information-input--textfield-first-name',
    inputTextfieldLastName: 'customer-address-information-input--textfield-last-name',
    inputTextfieldPhoneAreaCode: 'customer-address-information-input--textfield-phone-area-code',
    inputTextfieldPhoneNumber: 'customer-address-information-input--textfield-phone-number',
    inputTextfieldMobilePhoneNumber: 'customer-address-information-input--textfield-mobile-phone-number',
    inputTextfieldAddress: 'customer-address-information-input--textfield-address',
    inputButtonUpdate: 'customer-address-information-input--button-update',

    inputIconButtonEditRow: 'customer-address-information-input--icon-button-edit-row',

    entityFieldsContainer: 'customer-address-information-paper__entity-fields',
    entityFieldRow: 'customer-address-information-paper__entity-field-row',
    entityFieldLoading: 'customer-address-information-paper__entity-field-loading',
} as const;

export const caipCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

export const caipEntityTextfield = (addressEntityTypeId: number) =>
    `customer-address-information-input--textfield-address-entity-${addressEntityTypeId}`;

export const caipEntityAutocomplete = (addressEntityTypeId: number) =>
    `customer-address-information-input--autocomplete-address-entity-${addressEntityTypeId}`;

export const caipEntityFieldModifier = (addressEntityTypeId: number) =>
    `customer-address-information-field--address-entity-${addressEntityTypeId}`;
